/**
 * Standard Vuetify input bindings for TicketActionField slots.
 * Matches Reassign Ticket, Change Status, and other ticket-action dialogs.
 */
export const TAD_FIELD_INPUT = {
  variant: "solo-filled",
  flat: true,
  density: "comfortable",
  color: "primary",
  hideDetails: "auto",
  class: "tad-control",
};

/** Autocomplete / select — includes animated chevron */
export const TAD_FIELD_SELECT = {
  ...TAD_FIELD_INPUT,
  menuIcon: "mdi-chevron-down",
};

/** Compact table / inline controls (Create Ticket step 2) */
export const TAD_FIELD_COMPACT = {
  ...TAD_FIELD_SELECT,
  density: "compact",
  class: "tad-control field-compact",
};

export const TAD_FIELD_EXPANDED = {
  ...TAD_FIELD_SELECT,
  density: "compact",
  class: "tad-control field-expanded",
};

/** Merge activator props (menu/dialog) with standard field bindings */
export function mergeTadActivatorProps(fieldBind, activatorProps) {
  return { ...fieldBind, ...activatorProps };
}
